/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SubscriptionStatusDto = {
    productType: SubscriptionStatusDto.productType;
    status: string;
    cancelAtPeriodEnd: boolean;
    currentPeriodEnd?: string;
};

export namespace SubscriptionStatusDto {

    export enum productType {
        DOCTOR_APPOINTMENT = 'doctorAppointment',
        MONTHLY_START_PACKAGE = 'monthlyStartPackage',
        MONTHLY_MEDIUM_PACKAGE = 'monthlyMediumPackage',
        MONTHLY_PREMIUM_PACKAGE = 'monthlyPremiumPackage',
        COGNITIVE_TEST = 'cognitiveTest',
        MONTHLY_BASIC_PACKAGE = 'monthlyBasicPackage',
    }


}

